import { motion } from "framer-motion";
import { Globe2, Phone } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY } from "@/lib/site";

export const AnyRouteCard = ({ query = "" }) => (
  <motion.a href={PHONE_TEL} data-testid="any-route-card" whileHover={{ y: -4, rotate: 0.6 }} whileTap={{ scale: 0.98 }}
    initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }}
    className="group relative flex min-h-[92px] items-center gap-3 overflow-hidden rounded-2xl border-2 border-dashed border-brand/40 bg-brand-soft p-3 transition-colors hover:border-coral hover:bg-coral-soft">
    <span className="grid h-[68px] w-[68px] shrink-0 place-items-center rounded-xl bg-ink text-white transition-transform duration-500 group-hover:rotate-[20deg]">
      <Globe2 className="h-8 w-8" />
    </span>
    <span className="min-w-0 flex-1">
      <span className="block font-display text-[15px] font-extrabold leading-tight text-ink">
        {query ? `Flying to “${query}”?` : "Your route not here?"}
      </span>
      <span className="mt-1 block text-[11px] leading-snug text-slate-600">We book every route, worldwide — any city, any airline.</span>
      <span className="mt-1.5 flex items-center gap-1 text-xs font-extrabold text-coral"><Phone className="h-3.5 w-3.5" />{PHONE_DISPLAY}</span>
    </span>
  </motion.a>
);
